import * as Animate from "react-reveal";
import { ArrowUpRight } from "../../../components/svgs";
import Avatar1 from "../../../assets/images/png/talent-leader.webp";
import Avatar2 from "../../../assets/images/png/mba/mba-leader-woman-v1.png";
import Avatar3 from "../../../assets/images/png/bankole-adesina-v1.png";
import Avatar4 from "../../../assets/images/png/mba/mba-leader-man-v1.png";
import Avatar5 from "../../../assets/images/png/mba/mba-leader-hijab-v1.png";

const stages = [
  {
    number: "01",
    lead: "AI-supported sourcing, matching and assessed talent.",
    title: "Access Talent",
    people: [Avatar1, Avatar2, Avatar3],
    peopleLabel: "People ready to match",
    tag: "ASSESSED TALENT",
    desc: "Find professionals who have already demonstrated their ability.",
    cta: "Explore Talent",
    href: "#talent-network",
  },
  {
    number: "02",
    lead: "Contracts, onboarding and compliance.",
    title: "Hire Globally",
    people: [Avatar2, Avatar3, Avatar4],
    peopleLabel: "Human hiring support",
    tag: "COMPLIANCE READY",
    desc:
      "Move from selecting someone to legally engaging them across markets.",
    cta: "Start Hiring",
    href: "https://app.utiva.co/signup?goal=employer",
  },
  {
    number: "03",
    lead: "Payroll, workforce operations and employee management.",
    title: "Manage & Pay",
    people: [Avatar3, Avatar4, Avatar5],
    peopleLabel: "People supported globally",
    tag: "PAYROLL ACTIVE",
    desc:
      "Continue managing the relationship through the same Utiva infrastructure.",
    cta: "Explore Manage & Pay",
    href: "/pay",
  },
];

const HireArchitectureSection = () => {
  return (
    <section className="bg-[#f7f9fd] py-16 md:py-20 lg:py-24 px-4">
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <p className="flex items-center gap-3 text-primary font-poppins text-sm font-extrabold tracking-widest uppercase mb-6">
            <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
            The Global Hiring OS
          </p>
        </Animate.Fade>

        <Animate.Fade bottom>
          <h2 className="text-3xl md:text-4xl lg:text-5xl leading-tight font-poppins font-black mb-6 max-w-3xl tracking-[-0.03em]">
            <span className="text-default">One System.</span>{" "}
            <span className="text-primary">Every Step.</span>
          </h2>
        </Animate.Fade>

        <Animate.Fade bottom>
          <p className="text-gray text-base md:text-lg font-poppins leading-relaxed max-w-2xl mb-12 lg:mb-14">
            Talent access, global hiring and workforce operations are not
            separate products. They are one continuous workflow.
          </p>
        </Animate.Fade>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          {stages.map((stage) => (
            <Animate.Fade bottom key={stage.number}>
              <article className="border border-hire-line bg-white rounded-3xl flex flex-col p-7 h-full min-h-[520px]">
                <span className="text-[#9b6400] font-poppins text-base font-extrabold">
                  {stage.number}
                </span>
                <p className="text-gray font-poppins text-sm font-bold mt-8 mb-2">
                  {stage.lead}
                </p>
                <h3 className="text-primary font-poppins font-bold text-2xl md:text-3xl leading-snug mb-5">
                  {stage.title}
                </h3>

                <div className="flex items-center gap-3 -mt-1 mb-4">
                  <div className="flex items-center">
                    {stage.people.map((avatar, index) => (
                      <img
                        key={index}
                        src={avatar}
                        alt=""
                        className={`w-10 h-10 rounded-full object-cover border-2 border-white ${
                          index !== 0 ? "-ml-2.5" : ""
                        }`}
                      />
                    ))}
                  </div>
                  <span className="text-gray font-poppins text-xs font-bold leading-snug">
                    {stage.peopleLabel}
                  </span>
                </div>

                <div className="bg-primary rounded-2xl grid grid-cols-3 items-end gap-2 min-h-[125px] p-4">
                  <i className="not-italic bg-white/[0.12] rounded-md h-9"></i>
                  <i className="not-italic bg-white/[0.12] rounded-md h-14"></i>
                  <i className="not-italic bg-secondary rounded-md h-[72px]"></i>
                  <strong className="col-span-3 text-white font-poppins text-xs tracking-widest mt-1.5">
                    {stage.tag}
                  </strong>
                </div>

                <small className="text-gray font-poppins text-sm leading-relaxed my-6">
                  {stage.desc}
                </small>

                <a
                  href={stage.href}
                  {...(stage.href.startsWith("http") && {
                    target: "_blank",
                    rel: "noreferrer noopener",
                  })}
                  className="mt-auto pt-5 border-t border-hire-line text-primary font-poppins font-extrabold text-base flex items-center justify-between"
                >
                  {stage.cta}
                  <ArrowUpRight className="w-3.5 h-3.5" />
                </a>
              </article>
            </Animate.Fade>
          ))}
        </div>

        <Animate.Fade bottom>
          <div className="bg-primary text-white rounded-full flex flex-wrap items-center justify-between gap-5 w-full max-w-3xl mx-auto mt-8 px-6 py-4 font-poppins text-sm font-extrabold">
            <span>ACCESS</span>
            <b className="text-secondary font-normal">→</b>
            <span>HIRE</span>
            <b className="text-secondary font-normal">→</b>
            <span>MANAGE & PAY</span>
          </div>
        </Animate.Fade>
      </div>
    </section>
  );
};

export default HireArchitectureSection;
